import {RootState} from '../store';

export const getTitleDataGrid = (state: RootState) => state.dataGrid.title;

export const getShowSearchFieldDataGrid = (state: RootState) =>
  state.dataGrid.showSearchField;

export const getLabeAddButtonDataGrid = (state: RootState) =>
  state.dataGrid.labelAddButton;

export const getAddUrlDataGrid = (state: RootState) => state.dataGrid.addUrl;

export const getSearchValueDataGrid = (state: RootState) =>
  state.dataGrid.searchValue;

export const getSearchPlaceholderDataGrid = (state: RootState) =>
  state.dataGrid.searchPlaceholder;

export const getRefreshTableDataGrid = (state: RootState) =>
  state.dataGrid.refreshTable;

export const getTitleTableDataGrid = (state: RootState) =>
  state.dataGrid.titleTable;

export const getDataTableDataGrid = (state: RootState) =>
  state.dataGrid.dataTable;

export const getIsLoadingTableDataGrid = (state: RootState) =>
  state.dataGrid.isLoadingTable;

export const getTotalTableDataGrid = (state: RootState) => state.dataGrid.total;

export const getCurrentPageTableDataGrid = (state: RootState) =>
  state.dataGrid.currentPage;

export const getPageSizeTableDataGrid = (state: RootState) =>
  state.dataGrid.pageSize;

export const getSearchValuesDataGrid = (state: RootState) =>
  state.dataGrid.searchValues;

export const getShowSearchFieldsDataGrid = (state: RootState) =>
  state.dataGrid.showSearchFields;
